import React, { Fragment } from 'react'
import { FieldError } from './styles'

export default ReactDatesInput => ({ name, input: { value, onChange, onFocus, onBlur }, meta: { touched, error, active }, children, render, ...rest }) => {
  return (
    <Fragment>
      <ReactDatesInput
        id={name}
        date={value}
        focused={active}
        onDateChange={onChange}
        onFocusChange={({ focused }) => {
          if (focused) {
            onFocus()
          } else {
            onBlur()
          }
        }} 
        {...rest}
      />
      {touched && error && <FieldError>{error}</FieldError>}
    </Fragment>
  )
}



// WEBPACK FOOTER //
// ./src/Components/FormElements/toFinalFormDates.jsx